import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { BackgroundJobFileDownloadDto } from "@/api/dtos";
import type { BackgroundJobFileDownload } from "./_models/BackgroundJob";
import { toBackgroundJobFetchError } from "./backgroundJob.utils";

export interface GetBackgroundJobFileDownloadArgs {
  jobId: string;
  fileName: string;
}

/**
 * A presigned S3 download link for one of a job's files (GET /background-jobs/{id}/files/{fileName}).
 * Fetch on click (lazy query); never cached, since the link expires within minutes.
 */
export const getBackgroundJobFileDownloadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBackgroundJobFileDownload: builder.query<BackgroundJobFileDownload, GetBackgroundJobFileDownloadArgs>({
      queryFn: async (args) => {
        try {
          const res = await axios.get<BackgroundJobFileDownloadDto>(
            `${backendBase()}/background-jobs/${encodeURIComponent(args.jobId)}/files/${encodeURIComponent(args.fileName)}`,
            { headers: { Accept: "application/json" } },
          );
          const download: BackgroundJobFileDownload = { name: res.data.name, url: res.data.url, expiresAt: res.data.expiresAt };
          return { data: download };
        }
        catch (e) {
          return { error: toBackgroundJobFetchError(e) };
        }
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const getBackgroundJobFileDownload = getBackgroundJobFileDownloadApi.endpoints.getBackgroundJobFileDownload;
